export default __webpack_public_path__ + "static/icon-33-2-e7f32a49150c3434ffebece223ad61f0.png";